module.exports = __webpack_public_path__ + "img/247.Personal_attention.07cd8427.svg";